import { SimperDetails } from "@/features"

const SimperDetailsPage = () => {
  return <SimperDetails />
}

export default SimperDetailsPage